/* v1.2 */

qI = {};
qI.debug = false;
qI.baseMetricsSent = false;
qI.states = {};

qI.elements = [];
qI.elements["Product Card"] = ".product-card";
qI.elements["Quick Add"] = "#ShopNowContainer";

qI.page = {};
qI.page.scrollToY = window.innerHeight;
qI.page.scrollMaxY = document.documentElement.scrollHeight;
qI.page.performance = {};
qI.page.errors = [];
qI.page.events = [];
qI.page.sections = {};
qI.page.elements = {};

qI.clientVariables = {};
// qI.clientVariables.product_cards = 'product-card';
//qI.clientVariables.modals = '[data-modal]';

qI.intervalcount = setInterval(qIsender, 30000);
function qIsender() {
  qI.log("hidden");
  qI.send();
}

document.onvisibilitychange = () => {
  if (document.visibilityState === "hidden") {
    qI.log("hidden");
    qI.send();
  }
};

window.addEventListener("beforeunload", (event) => {
  qI.log("closing");
  qI.send();
});

window.addEventListener("pagehide", (event) => {
  qI.log("closing");
  qI.send();
});

/* CAPTURE MAX SCROLL */
onscrollend = (event) => {
  let newMaxScroll = window.innerHeight + window.scrollY;
  if (newMaxScroll > qI.page.scrollToY) {
    qI.page.scrollToY = newMaxScroll;
    qI.page.scrollMaxY = document.documentElement.scrollHeight;
  }
};

window.onerror = function (event, source, lineno, colon, error) {
  let err = {};
  err.event = event;
  err.source = source;
  err.lineno = lineno;
  err.colon = colon;
  err.error = "";
  if (error) {
    if (error.message) {
      err.error = error.message;
    } else {
      err.error = error.toString();
    }
  }
  qI.page.errors.push(err);
};

qI.send = function () {
  endVisibilityCounters();
  if (qI.baseMetricsSent == false) {
    qI.getPerformance();
  } else {
    delete qI.page.performance;
  }
  qI.log(qI.page);
  Shopify.analytics.publish("page_close", qI.page);
  qI.baseMetricsSent = true;
};

qI.log = function () {
  if (qI.debug == true) {
    let showtrace = false;
    for (let i = 0; i < arguments.length; i++) {
      let arg = arguments[i];
      if (arg == "trace") {
        showtrace = true;
      } else {
        console.log(arg);
      }
    }
    if (showtrace) {
      console.trace();
    }
  }
};

qI.getPerformance = function () {
  let performance = {};
  performance.resources = [];
  performance.timings = {};
  networkentries = window.performance.getEntries();
  networkentries.forEach((entry) => {
    //qI.log(entry);
    if (entry.type) {
      var per = {};
      per.type = entry.type;
      per.transferSize = entry.transferSize;
      per.duration = entry.duration;
      per.domInteractive = entry.domInteractive;
      per.domComplete = entry.domComplete;
      performance.timings = per;
    } else if (entry.entryType && entry.entryType == "resource") {
      if (entry.responseStatus == 404 || entry.transferSize > 12500) {
        var per = {};
        per.url = entry.name;
        per.initiatorType = entry.initiatorType;
        per.size = entry.transferSize;
        per.status = entry.responseStatus;
        per.type = entry.initiatorType;
        per.startTime = entry.startTime;
        per.duration = entry.duration;
        per.renderblocking = entry.renderBlockingStatus;
        performance.resources.push(per);
        // qI.log(entry);
      }
    }
  });

  qI.page.performance = performance;
};

const cardObserver = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      qI.intTarget = entry.target;
      qI.intTarget.setAttribute(
        "data-qiInsight",
        self.crypto.randomUUID().substring(0, 8)
      );
      let cardelement = qI.intTarget.querySelector("[data-product-id]");
      if (cardelement && entry.intersectionRatio > 0.5) {
        let productid = cardelement.getAttribute("data-product-id");
        var event = {};
        event.data = {};
        event.timestamp = new Date().toISOString();
        event.name = "product-card-shown";
        event.data.productid = productid;
        qI.page.events.push(event);
        cardObserver.unobserve(entry.target);
      }
    });

    //qI.log(qI.page.events);
  },
  { threshold: 0.5 }
);

const modalObserver = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      qI.intTarget = entry.target;

      var event = {};
      event.data = {};
      event.timestamp = new Date().toISOString();
      event.data.type = qI.intTarget.getAttribute("data-modal");
      if (entry.intersectionRatio > 0.5) {
        event.name = "modal-shown";
        qI.page.events.push(event);
        qI.intTarget.setAttribute(
          "data-qiInsight",
          self.crypto.randomUUID().substring(0, 8)
        );
      } else if (qI.intTarget.getAttribute("data-qiInsight")) {
        event.name = "modal-hidden";
        qI.page.events.push(event);
      }
    });

    //qI.log(qI.page.events);
  },
  { threshold: [0, 0.5] }
);

const sectionObserver = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      qI.intTarget = entry.target;
      var sectionuuid = qI.intTarget.getAttribute("data-qiInsight");
      if (entry.intersectionRatio > 0.5) {
        qI.page.sections[sectionuuid].startTime = Date.now();
      } else if (qI.page.sections[sectionuuid].startTime) {
        qI.page.sections[sectionuuid].endTime = Date.now();
        qI.page.sections[sectionuuid].viewtime = parseFloat(
          qI.page.sections[sectionuuid].viewtime +
            (qI.page.sections[sectionuuid].endTime -
              qI.page.sections[sectionuuid].startTime) /
              1000
        );
        delete qI.page.sections[sectionuuid].startTime;
        delete qI.page.sections[sectionuuid].endTime;
      }
      // qI.log('section',qI.page.sections[sectionuuid]);
    });
  },
  { threshold: [0, 0.5] }
);

const elementObserver = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      qI.intTarget = entry.target;
      var elementuuid = qI.intTarget.getAttribute("data-qiInsight");
      if (entry.intersectionRatio > 0.5) {
        let productinputs = entry.target.querySelectorAll(
          'input[name="product-id"]'
        );
        if (qI.intTarget.hasAttribute("qf-product-id")) {
          qI.page.elements[elementuuid].productId =
            qI.intTarget.getAttribute("qf-product-id");
        } else if (qI.intTarget.hasAttribute("data-product-id")) {
          qI.page.elements[elementuuid].productId =
            qI.intTarget.getAttribute("data-product-id");
        } else if (productinputs) {
          productinputs.forEach((productinput) => {
            qI.page.elements[elementuuid].productId =
              productinput.getAttribute("value");
          });
        }
        qI.page.elements[elementuuid].startTime = Date.now();
        qI.page.elements[elementuuid].viewCount++;
      } else if (qI.page.elements[elementuuid].startTime) {
        qI.page.elements[elementuuid].endTime = Date.now();
        qI.page.elements[elementuuid].viewtime = parseFloat(
          qI.page.elements[elementuuid].viewtime +
            (qI.page.elements[elementuuid].endTime -
              qI.page.elements[elementuuid].startTime) /
              1000
        );
        delete qI.page.elements[elementuuid].startTime;
        delete qI.page.elements[elementuuid].endTime;
      }
      //qI.log('elements',qI.page.elements[elementuuid],entry);
    });
  },
  { threshold: [0, 0.5] }
);

function qi_quickview(entry) {
  let qv = document.getElementById("shopify-section-api-quickview");
  if (!qv) {
    return false;
  }
  let productinfo = qv.querySelector('input[name="product-id"]');
  if (!productinfo) {
    return false;
  }
  let variantid = productinfo.getAttribute("value");
  var event = {};
  event.type = "quickview_shown";
  event.variantid = variantid;
  qI.page.events.push(event);
}

function endVisibilityCounters() {
  let sections = qI.page.sections;
  for (const [uuid, value] of Object.entries(sections)) {
    //qI.log(uuid,value);
    if (qI.page.sections[uuid].startTime) {
      qI.page.sections[uuid].endTime = Date.now();
      qI.page.sections[uuid].viewtime = parseFloat(
        qI.page.sections[uuid].viewtime +
          (qI.page.sections[uuid].endTime - qI.page.sections[uuid].startTime) /
            1000
      );
    }
  }

  let elements = qI.page.elements;
  for (const [uuid, value] of Object.entries(elements)) {
    //qI.log(uuid,value);
    if (qI.page.elements[uuid].startTime) {
      qI.page.elements[uuid].endTime = Date.now();
      qI.page.elements[uuid].viewtime = parseFloat(
        qI.page.elements[uuid].viewtime +
          (qI.page.elements[uuid].endTime - qI.page.elements[uuid].startTime) /
            1000
      );
    }
  }
}

const URLchangeobserver = new MutationObserver(() => {
  var currenturl = window.location.href;
  if (qI.page.url != currenturl) {
    qI.getURLInfo(currenturl);
    qI.send();
  }
});
URLchangeobserver.observe(document, { subtree: true, childList: true });

qI.getURLInfo = function (currenturl) {
  qI.page.url = currenturl;
  var parsedurl = URL.parse(currenturl);
  if (parsedurl.searchParams) {
    qI.filtersortFromURL(parsedurl.searchParams);
  }
};

qI.filtersortFromURL = function (searchparams) {
  qI.page.fs = {};
  for (const [key, value] of searchparams) {
    var filternode = document.querySelector('[value="' + escape(value) + '"]');
    var valuetext = value;
    if (valuetext != "") {
      if (!(key in qI.page.fs)) {
        qI.page.fs[key] = [];
      }
      qI.page.fs[key].push(valuetext);
    }
  }
};

window.addEventListener("click", (e) => {
  qI.log(e);
  e.path = e.composedPath();
  e.path.forEach(function (ee) {
    if (ee.getAttribute) {
      if (
        ee.getAttribute("button-wishlist") !== null &&
        ee.getAttribute("data-product-id")
      ) {
        let productid = ee.getAttribute("data-product-id");
        var event = {};
        event.data = {};
        event.timestamp = new Date().toISOString();
        if (ee.classList.contains("active-wishlist")) {
          event.name = "add-to-wishlist";
        } else {
          event.name = "remove-from-wishlist";
        }
        event.data.productid = productid;
        //qI.page.events.push(event);
      }
    }
  });
  qI.log(qI.page.events);
});

window.addEventListener("load", (event) => {
  /* Observer for Modals */
  if (qI.clientVariables.modals) {
    const modals = document.querySelectorAll(qI.clientVariables.modals);
    if (modals) {
      modals.forEach((modal) => {
        modalObserver.observe(modal);
      });
    }
  }

  /* Observer for Product Cards */
  if (qI.clientVariables.product_cards) {
    const cards = document.querySelectorAll(qI.clientVariables.product_cards);
    if (cards) {
      cards.forEach((card) => {
        cardObserver.observe(card);
      });
    }
  }

  /* Observer for Section Visibility */
  const sections = document.querySelectorAll(".shopify-section");
  //qI.log(sections);
  if (sections) {
    sectionIndex = 0;
    sections.forEach((section) => {
      let sectionData = {};
      var sectionuuid = self.crypto.randomUUID().substring(0, 8);
      section.setAttribute("data-qiInsight", sectionuuid);
      sOffsets = section.getBoundingClientRect();
      sectionData.classList = section.className
        .replace("shopify-section", "")
        .trim()
        .split(" ")
        .join("|");
      sectionData.id = section.id || sectionuuid;
      sectionData.viewtime = 0;
      sectionData.position = Math.round(sOffsets.top + window.scrollY);
      sectionData.index = sectionIndex++;
      //sectionData.textContent = section.textContent.trimStart().trimEnd().replace(/\s+/g, '\n');
      qI.page.sections[sectionuuid] = sectionData;
      //qI.log(sectionData);
      sectionObserver.observe(section);
    });
  }

  /* Observer for Section Visibility */

  if (qI.elements) {
    for (var k in qI.elements) {
      var elem_name = k;
      var elem_selector = qI.elements[k];
      const elements = document.querySelectorAll(elem_selector);
      //qI.log(elements);
      if (elements) {
        elementIndex = 0;
        elements.forEach((element) => {
          let elementData = {};
          var elementuuid = self.crypto.randomUUID().substring(0, 8);
          eOffsets = element.getBoundingClientRect();
          element.setAttribute("data-qiInsight", elementuuid);
          element.setAttribute("data-qiElem", elem_name);
          elementData.classList = element.className.trim().split(" ").join("|");
          elementData.id = element.id || elementuuid;
          elementData.viewtime = 0;
          elementData.type = elem_name;
          elementData.viewCount = 0;
          if (element.hasAttribute("data-variant-id")) {
            elementData.variantId = element.getAttribute("data-variant-id");
          }
          elementData.position = Math.round(eOffsets.top + window.scrollY);
          elementData.index = elementIndex++;
          //elementData.textContent = element.textContent.trimStart().trimEnd().replace(/\s+/g, '\n');
          qI.page.elements[elementuuid] = elementData;
          qI.log(elementData);
          elementObserver.observe(element);
        });
      }
    }
  }

  /* WATCH FOR NEWLY ADDED ELEMENTS */
  var Mutobserver = new MutationObserver(function (mutations) {
    mutations.forEach((mut) => {
      if (mut.addedNodes && mut.addedNodes[0] && mut.addedNodes[0].classList) {
        if (
          mut.addedNodes[0].classList.contains(qI.clientVariables.product_cards)
        ) {
          cardObserver.observe(mut.addedNodes[0]);
        }
      }
    });
  });

  Mutobserver.observe(document, {
    attributes: false,
    childList: true,
    characterData: false,
    subtree: true,
  });
});

/* CAPTURE FETCHES FOR SEARCHES ETC
const { fetch: originalFetch } = window;

window.fetch = async (...args) => {
    let [resource, config ] = args;
    const response = await originalFetch(resource, config);

    if(resource.includes("suggest?q")) {

        var searchmatch = resource.match(/q=(.*?)&/gm);
        if(searchmatch) {
            var searchquery = searchmatch[0].slice(2,-1);
        }
        var event = {};
        event.data = {};
        event.name = 'suggest';
        event.data.url = resource;
        event.data.query = searchquery;
        event.data.response = response;
        //qI.page.events.push(event)
    }

    return response;
};

 */